'use client';

import Image from 'next/image';

export default function LogoLoading() {
    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            aria-busy='true'
            aria-live='polite'
        >
            <div style={{ animation: 'pulseFade 1.2s ease-in-out infinite' }}>
                <Image
                    src='/images/vms/main-logo-vms.webp'
                    alt='Loading'
                    width={300}
                    height={100}
                    priority
                    className='rounded-full object-cover'
                />
            </div>

            <style>{`
                @keyframes pulseFade {
                    0%   { opacity: 0.55; transform: scale(0.98); }
                    50%  { opacity: 1;    transform: scale(1); }
                    100% { opacity: 0.55; transform: scale(0.98); }
                }
            `}</style>
        </div>
    );
}
